import React from "react";
import { ChartInformationCard } from "react-library";
import { useParams } from "react-router-dom";
import { Colors } from "../../../constants";
import { hexToRgb } from "../../../utils";

export type TInformationCard = {
  cardTitle: string;
  value: number;
  unit: string;
  information?: string;
};

type TProps = {
  informationCards: Array<TInformationCard>;
  width?: string;
};

const InformationCardRenderer: React.FC<TProps> = (props) => {
  const { informationCards } = props;
  const { sensor } = useParams();

  return (
    <div style={{ display: "flex",  marginTop: 12, marginBottom: 12, width: "100%", gap: 6}}>
      {informationCards.map((info, index) => {

        const isOddIndex = index & 1; // 0 based on index
        const greenColorCard = isOddIndex || informationCards.length === 1;
        const backgroundColor = greenColorCard ? hexToRgb(Colors.green, 0.1) : "white";

        return (
          <div key={`information-card-${index}-${sensor}`} style={{width: "32%"}}>
            <ChartInformationCard
              key={`information-card-${index}-${sensor}`}
              {...info}
              cardStyles={{ 
                height: "120px",
                backgroundColor,
                padding: "8px"
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default InformationCardRenderer;